<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1280px"
      title="丘成桐少年班、信息特长生初三年级"
      id-key="Junior9Id"
      :data="data"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      :before-save="onBeforeSave"
      @details-opened="onDetailsOpened"
      @create-opened="onCreateOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <table class="report-table no-border" border="1">
              <tr>
                <td colspan="25">
                  <div>
                    <span v-if="data.EnrollNo">报名序号：{{data.EnrollNo}}</span>
                    <span v-else>报名序号：(<span class="red">系统自动生成</span>)</span>
                  </div>
                  <div class="center large" style="margin:6px 0;">{{year}}年汕头市金山中学“丘成桐少年班”九年级学生报名信息表</div>
                  <div class="center large" style="margin:6px 0;">{{year}}年汕头市金山中学“信息学特长生”自主招生报名信息表</div>
                </td>
              </tr>
              <tr>
                <td class="center" style="width:13%;">姓名</td>
                <td class="center" colspan="4">{{data.FullName}}</td>
                <td class="center" colspan="2">性别</td>
                <td class="center" colspan="13">{{data.Sex==1?"男":"女"}}</td>
                <td class="center red bold small" rowspan="5" style="width:15%;">
                  <el-image v-if="!tbLoading" :src="'/api'+data.PicUrl" fit="cover" :preview-src-list="['/api'+data.PicUrl]" style="height: 180px;width: 90%;margin-top: 6px;" />
                </td>
              </tr>
              <tr>
                <td class="center">身份证号</td>
                <td class="center" colspan="4">{{data.IdCard}}</td>
                <td class="center" colspan="2">户籍地</td>
                <td class="center" colspan="13">{{data.Domicile}}</td>
              </tr>
              <tr>
                <td class="center">中考报名号(14位)</td>
                <td class="center" colspan="4">{{data.MiddleExamNo}}</td>
                <td class="center" colspan="2">就读学校所在区县</td>
                <td class="center" colspan="13">{{data.SchoolDistrict}}</td>
              </tr>
              <tr>
                <td class="center">就读初中</td>
                <td class="center" colspan="19">{{data.MiddleSchool}}</td>
              </tr>
              <tr>
                <td class="center">家长手机号码</td>
                <td class="center" colspan="19">{{data.Mobile}}</td>
              </tr>
              <tr>
                <td class="center" rowspan="2" v-if="data.EnrollQct">报名类型</td>
                <td class="center" v-else>报名类型</td>
                <td class="" colspan="24" v-if="data.EnrollInfo">
                  <div style="display: inline-block;vertical-align: top;">信息学特长生</div>
                  <div style="display: inline-block;margin-left: 1rem;">
                    {{enroll==="0"?"“专项测试、面试”模式（选择此模式不能兼报“丘班”）":"“55方案”模式（选择此模式可以兼报“丘班”）"}}
                    <div class="zm dis" v-if="data.EnrollInfoTest">
                      <el-upload
                        action="/api/PoJunior9/UploadPictureInfo"
                        :show-file-list="true"
                        :file-list="InfoTestPicUrls"
                        disabled
                        :on-preview="handlePreview">
                      </el-upload>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="data.EnrollQct">
                <td class="" colspan="24">丘成桐少年班 （第一轮遴选为参加“55方案”的综合测试）</td>
              </tr>
              <tr>
                <td class="center bold" colspan="25">
                  九年级成绩(本校初中毕业生人数，约 {{data.StudentNumber}} 人)
                </td>
              </tr>
              <tr>
                <td class="center">考试</td>
                <td class="center grade">语文</td>
                <td class="center grade">数学</td>
                <td class="center grade">英语</td>
                <td class="center grade">物理</td>
                <td class="center grade">化学</td>
                <td class="center grade">政治</td>
                <td class="center grade">历史</td>
                <td class="center grade">总分</td>
                <td class="center red bold" colspan="16">综合成绩列年级(选填一项)</td>
              </tr>
              <tr>
                <td class="center">上学期期中</td>
                <td class="center">{{data.MidYw}}</td>
                <td class="center">{{data.MidSx}}</td>
                <td class="center">{{data.MidYy}}</td>
                <td class="center">{{data.MidWl}}</td>
                <td class="center">{{data.MidHx}}</td>
                <td class="center">{{data.MidZz}}</td>
                <td class="center">{{data.MidLs}}</td>
                <td class="center">{{total1}}</td>
                <td class="center" colspan="15">{{data.MidSn==0?"前5%":(data.MidSn==1?"前30%":"30%后")}}</td>
              </tr>
              <tr>
                <td class="center">上学期期末</td>
                <td class="center">{{data.FinalYw}}</td>
                <td class="center">{{data.FinalSx}}</td>
                <td class="center">{{data.FinalYy}}</td>
                <td class="center">{{data.FinalWl}}</td>
                <td class="center">{{data.FinalHx}}</td>
                <td class="center">{{data.FinalZz}}</td>
                <td class="center">{{data.FinalLs}}</td>
                <td class="center">{{total2}}</td>
                <td class="center" colspan="15">{{data.FinalSn==0?"前5%":(data.FinalSn==1?"前30%":"30%后")}}</td>
              </tr>
              <tr>
                <td class="center bold">下学期区统考</td>
                <td class="center">{{data.UnifiedYw}}</td>
                <td class="center">{{data.UnifiedSx}}</td>
                <td class="center">{{data.UnifiedYy}}</td>
                <td class="center">{{data.UnifiedWl}}</td>
                <td class="center">{{data.UnifiedHx}}</td>
                <td class="center">{{data.UnifiedZz}}</td>
                <td class="center">{{data.UnifiedLs}}</td>
                <td class="center">{{total3}}</td>
                <td class="center" colspan="15">{{data.UnifiedSn==0?"前5%":(data.UnifiedSn==1?"前30%":"30%后")}}</td>
              </tr>
              <tr>
                <td class="center">综合素质<br />评价总得分<br />(选填一项)</td>
                <td class="center" colspan="24">
                  <span v-if="data.QualityScore==0">25分</span>
                  <span v-else-if="data.QualityScore==1">24分</span>
                  <span v-else-if="data.QualityScore==2">23分</span>
                  <span v-else-if="data.QualityScore==3">≤22分</span>
                </td>
              </tr>
              <tr>
                <td class="center" rowspan="3">承诺：</td>
                <td class="center" colspan="24">
                  我们郑重承诺，以上所填内容完全真实准确。
                  <br />否则，愿意承担取消遴选资格或录取资格的后果。
                </td>
              </tr>
              <tr>
                <td class="center" colspan="2">家长签名：</td>
                <td class="center bold" colspan="23">
                  <el-image v-if="data.ParentSignUrl" :src="'/api'+data.ParentSignUrl" fit="contain" :preview-src-list="['/api'+data.ParentSignUrl]" style="height: 80px;width: 160px;" />
                  <span v-else>(确认提交本信息表后，默认家长和考生签名完成!)</span>
                </td>
              </tr>
              <tr>
                <td class="center" colspan="2">学生签名：</td>
                <td class="center" colspan="2">
                  <el-image v-if="data.StudentSignUrl" :src="'/api'+data.StudentSignUrl" fit="contain" :preview-src-list="['/api'+data.StudentSignUrl]" style="height: 80px;width: 160px;" />
                </td>
                <td class="center" colspan="21" v-if="data.AddTime">{{toYMString(data.AddTime)}}</td>
                <td class="center" colspan="21" v-else>{{year}}年{{month}}月</td>
              </tr>
              <tr>
                <td class="bold" colspan="25">
                  <span class="red">特别提示：</span>
                  <span class="blue">1、本表打印完成后，须在“电子彩照”位置贴上近期一寸彩照，并完成签名!!</span>
                  <div class="blue" style="text-indent:5rem;">2、本表于参加遴选时交给现场老师。</div>
                </td>
              </tr>
            </table>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <span class="statusText">状态：{{statusText}}</span>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <el-dialog :visible.sync="dialogVisible" title="查看图片">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
const date = new Date();
const year = date.getFullYear();
const month = date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;

import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require("@/api/po/junior9").default,
      data: {
        Junior9Id: 0,
        ParentId: 0,
        EnrollNo: "",
        FullName: "",
        Sex: null,
        IdCard: "",
        Domicile: "",
        MiddleExamNo: "",
        MiddleSchool: "",
        SchoolDistrict: "",
        Mobile: "",
        EnrollInfo: false,
        EnrollInfoTest: false,
        EnrollInfo55: false,
        EnrollQct: false,
        //------------
        StudentNumber: null,
        MidYw: null,
        MidSx: null,
        MidYy: null,
        MidWl: null,
        MidHx: null,
        MidZz: null,
        MidLs: null,
        MidSn: null,
        FinalYw: null,
        FinalSx: null,
        FinalYy: null,
        FinalWl: null,
        FinalHx: null,
        FinalZz: null,
        FinalLs: null,
        FinalSn: null,
        UnifiedYw: null,
        UnifiedSx: null,
        UnifiedYy: null,
        UnifiedWl: null,
        UnifiedHx: null,
        UnifiedZz: null,
        UnifiedLs: null,
        UnifiedSn: null,
        QualityScore: null,
        //------------
        PicUrl: "",
        ParentSignUrl: "",
        StudentSignUrl: "",
        InfoTestPicUrls: "",
        InfoTestPicNames: "",
        Status: 0,
        BirthDate: "",
        AddTime: "",
      },
      InfoTestPicUrls: [],
      dialogVisible: false,
      dialogImageUrl: "",
      tbLoading: true,
      enroll: null,
      year,
      month,
      isMB: this.$store.state.isMB,
      rules: {
        
      },
    };
  },
  computed: {
    statusText() {
      var result = "";
      switch (this.data.Status) {
        case 0:
          result = "待提交";
          break;
        case 1:
          result = "待审核";
          break;
        case 2:
          result = "审核未通过";
          break;
        case 3:
          result = "审核通过";
          break;
      }
      return result;
    },
    total1() {
      var total = 0;
      var e = this.data;
      total += Number(e.MidYw);
      total += Number(e.MidSx);
      total += Number(e.MidYy);
      total += Number(e.MidWl);
      total += Number(e.MidHx);
      total += Number(e.MidZz);
      total += Number(e.MidLs);
      return Math.floor(total * 10) / 10;
    },
    total2() {
      var total = 0;
      var e = this.data;
      total += Number(e.FinalYw);
      total += Number(e.FinalSx);
      total += Number(e.FinalYy);
      total += Number(e.FinalWl);
      total += Number(e.FinalHx);
      total += Number(e.FinalZz);
      total += Number(e.FinalLs);
      return Math.floor(total * 10) / 10;
    },
    total3() {
      var total = 0;
      var e = this.data;
      total += Number(e.UnifiedYw);
      total += Number(e.UnifiedSx);
      total += Number(e.UnifiedYy);
      total += Number(e.UnifiedWl);
      total += Number(e.UnifiedHx);
      total += Number(e.UnifiedZz);
      total += Number(e.UnifiedLs);
      return Math.floor(total * 10) / 10;
    },
  },
  methods: {
    onCreateOpened() {
      this.tbLoading = false;
    },
    onDetailsOpened(data) {
      this.tbLoading = false;
      this.data.AddTime = data.AddTime;
      if(data.EnrollInfo) {
        this.enroll = data.EnrollInfoTest?"0":"1";
      } else this.enroll = null;
      var urlArr = ["InfoTestPicUrls"];
      var urlArr2 = ["InfoTestPicNames"];
      urlArr.forEach((e,index) => {
        if(data[e]) {
          var arr = data[e].split(",");
          var arr2 = data[urlArr2[index]].split(",");
          arr.forEach((n,i) => {
            this[e].push({ url: n, name: arr2[i] });
          })
        }
      });
    },
    onBeforeSave() {
      return false;
    },
    toYMString(v) {
      if(!v) return "";
      var date = this.$commonJs.toDateString(v);
      var arr = date.split("/");
      return arr[0] + "年" + arr[1] + "月";
    },
    handlePreview(file) {
      this.dialogImageUrl = "/api" + file.url;
      this.dialogVisible = true;
    },
    onClosed() {
      this.InfoTestPicUrls = [];
      this.tbLoading = true;
      this.enroll = null;
    },
  }
};
</script>
<style lang="scss">
.report-table {
  border-spacing: 0;
  border-collapse: collapse;
  width: 100%;
  font-size: 16px;
  td {
    padding: 6px 8px;
  }
  .el-input,.el-select {
    width: 100%;
  }
  .center {
    text-align: center;
  }
  .right {
    text-align: right;
  }
  .red {
    color: #f11;
  }
  .blue {
    color: #11f;
  }
  .small {
    font-size: 14px;
  }
  .large {
    font-size: 18px;
  }
}
.statusText {
  color:#F11;
  float:left;
  font-weight: bold;
  line-height: 34px;
  margin-left: 8px;
  font-size: 16px;
}
.zm {
  font-size: 16px;
  margin-bottom: 0;
}
.dis .el-upload {
  display: none;
}
</style>